<template>
  <ModalBase :show-modal="true" @close-modal="close" :auto-h="true" :narrow="true">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
            <span v-if="!viewInviteId">{{ $gettext('Your received invitations') }}</span>
            <div 
                v-if="viewInviteId" 
                class="bg-info rounded-circle d-inline-flex align-items-center justify-content-center back-button"
                @click="viewInviteId = null">
                <font-awesome-icon icon="fa fa-arrow-left" class="text-white" />
            </div>
        </template>
      </TitleBar>
    </template>

    <template v-slot:maincontent>
        <div v-if="!viewInviteId" style="min-height: 260px;">
            <ul class="list-group">
                <li
                    v-for="invite in pendingInvites"
                    :key="invite.id"
                    class="list-group-item d-flex justify-content-between align-items-center"
                    style="cursor: pointer;"
                    @click="viewInviteId = invite.id"
                >
                    {{ invite.company_name }} from {{ invite.user_name }}
                </li>
            </ul>
        </div>

        <div v-if="viewInviteId" style="min-height: 208px;">
            <dl class="row mr-2 ml-2 pt-2 details-box">
                <dt class="col-sm-4">
                    {{ $gettext('Company name') }}
                </dt>
                <dd class="col-sm-8">
                    {{ selectedInvite.company_name }}
                </dd>

                <dt class="col-sm-4">
                    {{ $gettext('Sent by') }}
                </dt>
                <dd class="col-sm-8">
                    {{ selectedInvite.user_name }}
                </dd>

                <dt class="col-sm-4">
                    {{ $gettext('On') }}
                </dt>
                <dd class="col-sm-8">
                    {{ selectedInvite.created | formatDate }}
                </dd>

                <dt class="col-sm-4">
                    {{ $gettext('Message') }}
                </dt>
                <dd class="col-sm-8">
                    {{ selectedInvite.message }}
                </dd>
            </dl>
            <i class="mt-3">{{ $gettext('By accepting this invitation, you agree to join') }} <strong>{{ selectedInvite.company_name }}</strong> {{ $gettext('as a team member.') }}</i>
        </div>
    </template>

    <template v-slot:actions>
        <div v-if="viewInviteId" class="d-flex justify-content-center">
            <GekkoButton 
                :text="$gettext('Accept')"
                @click="acceptInvite" 
                class="mr-2"
            />
            <GekkoButton 
                variant="danger" 
                :text="$gettext('Reject')"
                @click="rejectInvite" 
            />
        </div>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import { mapActions } from "vuex";

export default {
  name: "InviteListModal",
  components: { ModalBase, TitleBar, GekkoButton },
  props: {
    pendingInvites: {
        type: Array,
        default: () => []
    }
  },
  data() {
    return {
      viewInviteId: null
    }
  },
  computed: {
    selectedInvite() {
        if (this.viewInviteId) return this.pendingInvites.find(invite => invite.id === this.viewInviteId)
        return null
    }
  },
  created() {

  },
  methods: {
    ...mapActions({
        acceptInvitation: 'notifications/acceptInvite',
        rejectInvitation: 'notifications/rejectInvite'
    }),
    close() {
        this.$emit('close-modal');
    },
    acceptInvite() {
        this.acceptInvitation({ invite_code: this.selectedInvite.invite_code, user_name: this.selectedInvite.user_name }).then(() => {
            localStorage.setItem('company_id', this.selectedInvite.company_profile)
            window.location.href = window.Urls['gekko_dashboard']()
        })
    },
    rejectInvite() {
        this.rejectInvitation({ invite_code: this.selectedInvite.invite_code, user_name: this.selectedInvite.user_name }).then(() => {
            this.close()
        })
    }
  }
}
</script>

<style scoped>
.back-button {
    width: 32px;
    height: 32px;
    padding: 20px;
    cursor: pointer;
}

.details-box {
    border: solid 1px #c5c5c5;
    border-radius: 10px;
    background-color: #c8c8c83b;
}
</style>